import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import uiheader from "../../../../assets/images/docs/ui-header.png";
import uiworkspaces from "../../../../assets/images/docs/ui-workspace.png";
import uipanel from "../../../../assets/images/docs/ui-panel.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  uiheader,
  uiworkspaces,
  uipanel,
  React
};